// extracted by mini-css-extract-plugin
module.exports = {"pt-withdraw-detail":"pt-withdraw-detail-7c6d8207e592e2446f19a599a7f87dc5","el-checkbox":"el-checkbox-70fcd74a0cb49ce96f7030bfc2aa7ba0"};